import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Modal, ModalControlModalProps, Text } from '@frontend/design-system';

interface Props extends ModalControlModalProps {
  onSetUpClick: () => void;
}

export const OnboardingFlowInitiatorModal = ({ onSetUpClick, ...modalProps }: Props) => {
  const { t } = useTranslation('schedule-onboarding');

  return (
    <Modal {...modalProps} maxWidth={800}>
      <Modal.Header onClose={modalProps.onClose}>
        {t('Stop wasting hours on weekly appointment confirmations')}
      </Modal.Header>
      <Modal.Body>
        <Text weight='regular'>
          {t(
            'Watch how structured appointment management frees up 3+ hours weekly for patient care instead of admin tasks'
          )}
        </Text>
        <iframe
          allowFullScreen
          css={videoStyle}
          src='https://fast.wistia.net/embed/iframe/6g5vfkqz8b?wmode=opaque'
          title={t('Schedule Functionality Demo Video')}
        ></iframe>
      </Modal.Body>
      <Modal.Footer
        primary={{ label: t('Set Up Now'), onClick: onSetUpClick }}
        secondary={{ label: t('Remind Me Later'), onClick: modalProps.onClose }}
      />
    </Modal>
  );
};

const videoStyle = css({
  border: 'none',
  minHeight: '51vh',
  width: '100%',
  height: '100%',
  borderRadius: theme.borderRadius.large,
  overflow: 'hidden',
});
